import { useMemo } from 'react';
import { ApplicationRoutes } from 'src/constants/applicationRoutes';
import { profileRefactorSectionSearch } from 'src/features/userProfileRefactor/travelerProfileConstants';
import { useEnableObtBetaFeatures } from './useEnableObtBetaFeaturesHook';

export type ObtProfileCardLocation = {
  pathname: string;
  search?: string;
};

/**
 * Legacy profile route by default; refactor preview + "(Beta)" labels when user has ObtBeta role.
 */
export function useObtProfileNav() {
  const obtBeta = useEnableObtBetaFeatures();

  return useMemo(() => {
    const profilePath = obtBeta
      ? ApplicationRoutes.account.userProfileRefactor
      : ApplicationRoutes.account.userProfileManagement;

    const userProfilesLabel = obtBeta ? 'User Profiles (Beta)' : 'User Profiles';
    const myProfileLabel = obtBeta ? 'My Profile (Beta)' : 'My Profile';

    const cardSearch = profileRefactorSectionSearch('card');
    const cardLocation: ObtProfileCardLocation = obtBeta
      ? { pathname: ApplicationRoutes.account.userProfileRefactor, search: cardSearch }
      : { pathname: ApplicationRoutes.account.userProfileManagement };

    const profileCardHref = obtBeta
      ? `${ApplicationRoutes.account.userProfileRefactor}${cardSearch}`
      : ApplicationRoutes.account.userProfileManagement;

    return {
      obtBeta,
      profilePath,
      userProfilesLabel,
      myProfileLabel,
      cardLocation,
      profileCardHref
    };
  }, [obtBeta]);
}
